import { Head } from 'vite-react-ssg';
import { jsonLd } from '@/components/SEO';
import { AUTHOR, EMAIL, PHONE_E164, SITE_DESCRIPTION, SITE_NAME, SITE_ORIGIN } from '@/lib/site';

// Site-wide entity. No sameAs to any other brand site (CONTENT-SPEC §3.4).
const organization = {
  '@context': 'https://schema.org',
  '@type': ['ProfessionalService', 'Organization'],
  '@id': `${SITE_ORIGIN}/#organization`,
  name: SITE_NAME,
  url: `${SITE_ORIGIN}/`,
  logo: {
    '@type': 'ImageObject',
    url: `${SITE_ORIGIN}/icon-512.png`,
    width: 512,
    height: 512,
  },
  description: SITE_DESCRIPTION,
  email: EMAIL,
  ...(PHONE_E164 ? { telephone: PHONE_E164 } : {}),
  founder: {
    '@type': 'Person',
    '@id': `${SITE_ORIGIN}/about#engineer-heading`,
    name: AUTHOR.name,
    url: `${SITE_ORIGIN}/about#engineer-heading`,
  },
  areaServed: ['US', 'CA'],
  knowsAbout: [
    'Oracle WebCenter Content',
    'Oracle WebCenter Imaging',
    'Oracle WebCenter Enterprise Capture',
    'Oracle WebCenter Forms Recognition',
    'Oracle WebCenter Portal',
    'Oracle WebCenter Sites',
    'Oracle Fusion Middleware 12c to 14c upgrades',
    'Oracle SOA Suite',
    'Oracle WebLogic Server',
    'Oracle E-Business Suite integration',
    'Oracle Fusion Cloud integration',
    'Oracle PeopleSoft integration',
    'JD Edwards integration',
    'Oracle Cloud Infrastructure',
  ],
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'sales',
    availableLanguage: 'English',
    url: `${SITE_ORIGIN}/contact`,
  },
};

const OrganizationSchema = () => (
  <Head>
    <script type="application/ld+json">{jsonLd(organization)}</script>
  </Head>
);

export default OrganizationSchema;
